(function () {
  'use strict';

  var STORAGE_KEY = 'if_consent_v1';
  var CATEGORIES = ['essential', 'analytics', 'marketing', 'preferences'];

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (_) { return null; }
  }

  function write(state) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (_) {}
  }

  function defaultState() {
    return {
      decided: false,
      essential: true,
      analytics: false,
      marketing: false,
      preferences: false,
      ts: Date.now()
    };
  }

  function applyShopifyPrivacy(state) {
    if (!window.Shopify || !window.Shopify.customerPrivacy) return;
    try {
      window.Shopify.customerPrivacy.setTrackingConsent({
        analytics: !!state.analytics,
        marketing: !!state.marketing,
        preferences: !!state.preferences,
        sale_of_data: !!state.marketing
      }, function () {});
    } catch (e) {}
  }

  function loadGatedScripts(state) {
    // Analytics tier
    if (state.analytics) {
      document.querySelectorAll('script[type="text/plain"][data-consent="analytics"]').forEach(function (el) {
        var s = document.createElement('script');
        for (var i = 0; i < el.attributes.length; i++) {
          var a = el.attributes[i];
          if (a.name === 'type' || a.name === 'data-consent') continue;
          s.setAttribute(a.name, a.value);
        }
        s.text = el.text;
        el.parentNode.replaceChild(s, el);
      });
    }
    // Marketing tier
    if (state.marketing) {
      document.querySelectorAll('script[type="text/plain"][data-consent="marketing"]').forEach(function (el) {
        var s = document.createElement('script');
        for (var i = 0; i < el.attributes.length; i++) {
          var a = el.attributes[i];
          if (a.name === 'type' || a.name === 'data-consent') continue;
          s.setAttribute(a.name, a.value);
        }
        s.text = el.text;
        el.parentNode.replaceChild(s, el);
      });
    }
  }

  function setState(next) {
    next.decided = true;
    next.ts = Date.now();
    write(next);
    applyShopifyPrivacy(next);
    loadGatedScripts(next);
    document.documentElement.setAttribute('data-consent-decided', '1');
    document.dispatchEvent(new CustomEvent('consent:changed', { detail: next }));
  }

  function acceptAll() {
    setState({ essential: true, analytics: true, marketing: true, preferences: true });
    hideBanner();
  }
  function rejectAll() {
    setState({ essential: true, analytics: false, marketing: false, preferences: false });
    hideBanner();
  }
  function saveCustom(form) {
    var state = { essential: true };
    CATEGORIES.forEach(function (c) {
      if (c === 'essential') return;
      var input = form.querySelector('input[name="consent-' + c + '"]');
      state[c] = !!(input && input.checked);
    });
    setState(state);
    hideBanner();
  }

  function showBanner() {
    var banner = document.getElementById('if-consent-banner');
    var modal = document.getElementById('if-consent-modal');
    if (banner) banner.removeAttribute('hidden');
    if (modal) modal.setAttribute('hidden', '');
    document.documentElement.setAttribute('data-consent-banner', '1');
  }

  function hideBanner() {
    var banner = document.getElementById('if-consent-banner');
    var modal = document.getElementById('if-consent-modal');
    if (banner) banner.setAttribute('hidden', '');
    if (modal) modal.setAttribute('hidden', '');
    document.documentElement.removeAttribute('data-consent-banner');
  }

  function openModal() {
    var modal = document.getElementById('if-consent-modal');
    var banner = document.getElementById('if-consent-banner');
    var state = read() || defaultState();
    if (modal) {
      CATEGORIES.forEach(function (c) {
        if (c === 'essential') return;
        var input = modal.querySelector('input[name="consent-' + c + '"]');
        if (input) input.checked = !!state[c];
      });
      modal.removeAttribute('hidden');
    }
    if (banner) banner.setAttribute('hidden', '');
  }

  function closeModal() {
    var modal = document.getElementById('if-consent-modal');
    if (modal) modal.setAttribute('hidden', '');
    var existing = read();
    if (!existing || !existing.decided) showBanner();
  }

  function checkHashTrigger() {
    if (location.hash === '#cookie-settings') {
      openModal();
      if (history.replaceState) history.replaceState(null, '', location.pathname + location.search);
    }
  }

  function bind() {
    window.addEventListener('hashchange', checkHashTrigger);

    document.body.addEventListener('click', function (e) {
      var link = e.target.closest('a[href$="#cookie-settings"], a[href="#cookie-settings"]');
      if (link) { e.preventDefault(); openModal(); return; }

      var t = e.target.closest('[data-consent-action]');
      if (!t) return;
      var action = t.getAttribute('data-consent-action');
      if (action === 'accept-all') { acceptAll(); }
      else if (action === 'reject-all') { rejectAll(); }
      else if (action === 'customize') { openModal(); }
      else if (action === 'save') {
        var form = t.closest('form') || document.getElementById('if-consent-modal');
        if (form) saveCustom(form);
      }
      else if (action === 'open') { e.preventDefault(); openModal(); }
      else if (action === 'close-modal') { closeModal(); }
    });
  }

  function init() {
    var state = read();
    bind();
    checkHashTrigger();

    if (state && state.decided) {
      applyShopifyPrivacy(state);
      loadGatedScripts(state);
      document.documentElement.setAttribute('data-consent-decided', '1');
    } else {
      showBanner();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.IFConsent = { open: openModal, accept: acceptAll, reject: rejectAll, read: read };
})();
